import {
    GET_BANNER,
    GET_NEWS,
    GET_NEWS_ID,
    GET_GALLERY,
    GET_ANNOUNCEMENT,
    GET_BANNER_SATKER,
    GET_GALLERY_SATKER,
    GET_PESAN_SATKER,
    GET_BIRTHDAY_SATKER,
    GET_NEWS_SATKER,
    GET_NEWS_SATKER_ID,
    GET_NOTIFICATIONS,
    GET_COUNT_NOTIFICATIONS,
    READ_NOTIFICATION
} from "shared/constants/ActionTypes";

const Banner = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const BannerSatker = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const GallerySatker = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const BirthDaySatker = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const PesanAtasanSatker = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const News = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const Gallery = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const Announcement = {
    count: null,
    next: null,
    previous: null,
    results: []
}

const Notifications = {
    count: 0,
    next: null,
    previous: null,
    results: [],
    counter: null
}

const NewsSatker = {
    count: null,
    next: null,
    previous: null,
    results: []
}

const initialState = {
    banner: Banner,
    news: News,
    gallery: Gallery,
    bannerSatker: BannerSatker,
    gallerySatker: GallerySatker,
    pesanAtasanSatker: PesanAtasanSatker,
    birthdaySatker: BirthDaySatker,
    announcement: Announcement,
    notifications: Notifications,
    newsSatker: NewsSatker,
    newsId: null,
    newsSatkerId: null
};

const portalReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BANNER: {
            return { ...state, banner: action.payload.data }
        }
        case GET_NEWS: {
            return { ...state, news: action.payload.data }
        }
        case GET_GALLERY: {
            return { ...state, gallery: action.payload.data }
        }
        case GET_ANNOUNCEMENT: {
            const refresh = action.payload.refresh
            if (refresh) {
                return {
                    ...state,
                    announcement: {
                        ...action.payload.data,
                        results: [...state.announcement.results, ...action.payload.data.results]
                    }
                }
            } else {
                return { ...state, announcement: action.payload.data }
            }
        }
        case GET_BANNER_SATKER: {
            return { ...state, bannerSatker: action.payload.data }
        }
        case GET_BIRTHDAY_SATKER: {
            return { ...state, birthdaySatker: action.payload.data }
        }
        case GET_GALLERY_SATKER: {
            return { ...state, gallerySatker: action.payload.data }
        }
        case GET_PESAN_SATKER: {
            return { ...state, pesanAtasanSatker: action.payload.data }
        }
        case GET_NEWS_SATKER: {
            return { ...state, newsSatker: action.payload.data }
        }
        case GET_NEWS_ID: {
            return { ...state, newsId: action.payload.data }
        }
        case GET_NEWS_SATKER: {
            return { ...state, newsSatker: action.payload.data }
        }
        case GET_NEWS_SATKER_ID: {
            return { ...state, newsSatkerId: action.payload.data }
        }
        case GET_NOTIFICATIONS: {
            const refresh = action.payload.refresh
            if (refresh) {
                return {
                    ...state,
                    notifications: {
                        ...state.notifications,
                        ...action.payload.data,
                        results: [...state.notifications.results, ...action.payload.data.results],
                    }
                }
            } else {
                return { ...state, notifications: {...state.notifications, ...action.payload.data} }
            }
        }
        case GET_COUNT_NOTIFICATIONS: {
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    counter: action.payload.data.results
                }
            }
        }
        case READ_NOTIFICATION: {
            let unreadCount = state.notifications.counter.unread_count - 1

            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    counter: {
                        ...state.notifications.counter,
                        unread_count: unreadCount
                    }
                }
            }
        }
        default: {
            return state;
        }
    }
};

export default portalReducer;